<template>
  <Legenda
    titulo="Curva ABC - Rentabilidade"
    class-content="text-center cursor-help pt-3 mt-n3"
    :top="top"
    :bottom="bottom"
  >
    {{texto}}

    <template #legenda>
      <p class="ma-0">
        Classificação voltada para o resultado comercial, que visa segmentar de formas distintas a
        importância comercial de um determinado SKU, frente a rentabilidade geral.
      </p>

      <ul class="ml-n2 my-1">
        <li>A - Rentabilidade Elevada</li>
        <li>B - Rentabilidade Média</li>
        <li>C - Rentabilidade Baixa</li>
      </ul>
    </template>
  </Legenda>
</template>

<script>
import Legenda from "../../../produto/detalhes/Legenda.vue";

export default {
  name: "LegendaCurvaAbcRentabilidade",
  components: {
    Legenda
  },
  props: {
    texto: String,
    top: Boolean,
    bottom: Boolean,
  }
}
</script>

<style scoped>

</style>
